<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="tipoSituacao.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import TipoSituacao from '@/domain/tipoSituacao/TipoSituacao';

export default {
  name: 'ModalCadastroTipoSituacao',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tipoSituacao: {
      type: Object,
      default: () => new TipoSituacao()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  computed: {
    computedTitle() {
      return this.tipoSituacao.IdTipoSituacao ? 'Editar Tipo Situacao' : 'Novo Tipo Situacao';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  methods: {
    ...mapActions([
      'addTipoSituacao',
      'updateTipoSituacao',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async adiciona() {
      if (!this.tipoSituacao.IdTipoSituacao && this.tipoSituacao.Descricao) {
        this.loading = true;
        const newTipoSituacao = Object.assign({}, this.tipoSituacao);
        try {
          await this.addTipoSituacao(newTipoSituacao);
          this.showNotification({ text: `Tipo Situacao: ${newTipoSituacao.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoSituacaoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o tipo Situacao: ${error}.`, status: 'error' });
        }
      } else if (this.tipoSituacao.IdTipoSituacao && this.tipoSituacao.Descricao) {
        this.loading = true;
        const updTipoSituacao = Object.assign({}, this.tipoSituacao);
        try {
          await this.updateTipoSituacao(updTipoSituacao);
          this.showNotification({ text: `Tipo Situacao: ${updTipoSituacao.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoSituacaoAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o tipo Situacao: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do tipo Situacao.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
